import { Box, Skeleton, Paper } from '@mui/material';

const ServerLogsSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Multiple Log Entry Skeletons */}
      {[1, 2, 3].map(index => (
        <Paper
          key={index}
          elevation={1}
          sx={{
            p: 3,
            borderRadius: '12px',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            backgroundColor: '#ffffff',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {/* Header Skeleton */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={120} height={20} />
            </Box>

            {/* JSON Content Skeleton */}
            <Box sx={{ mt: 1 }}>
              {/* Multiple lines of skeleton for JSON structure */}
              <Skeleton variant="text" width="100%" height={16} />
              <Skeleton variant="text" width="90%" height={16} />
              <Skeleton variant="text" width="95%" height={16} />
              <Skeleton variant="text" width="85%" height={16} />
              <Skeleton variant="text" width="92%" height={16} />
              <Skeleton variant="text" width="88%" height={16} />
              <Skeleton variant="text" width="96%" height={16} />
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default ServerLogsSkeleton;
